import React                                        from "react";
import { BrowserRouter, Routes, Route }             from 'react-router-dom';
import Layout                                       from "./components/Layout";
import ProfiloPage                                  from "./pages/ProfiloPage";
import { AuthProvider }                             from "./components/service/AuthContext";
import Login                                        from "./pages/Login";
import Register                                     from "./pages/Register";
import PrivateRoute                                 from "./components/PrivateRoute";
import TabelleResi                                  from "./pages/cliente/dettaglioReso/TabelleResi";
import ResiPage                                     from "./pages/cliente/ResiPage";
import MerceDanneggiataForm                         from "./pages/cliente/avviaReso/MerceDanneggiataForm";
import MerceNonConformeForm                         from "./pages/cliente/avviaReso/MerceNonConformeForm";
import DOAForm                                      from "./pages/cliente/avviaReso/DOAForm";
import RiparazioneForm                              from "./pages/cliente/avviaReso/RiparazioneForm";
import DashboardSAT                                 from './pages/SAT/DashboardSAT';
import ChatPageSAT                                  from "./pages/SAT/ChatPageSAT";
import ChatPageCliente                              from "./pages/cliente/ChatPageCliente";
import NotFoundPage                                 from "./components/NotFoundPage";
import ForgotPasswordComponent                      from "./components/ForgotPasswordComponent";


const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/login' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/forgotPassword' element={<ForgotPasswordComponent />} />

          <Route element={<Layout />}>

          <Route path="/resi" element={
            <PrivateRoute roles={['CLIENTE']}>
              <ResiPage />
            </PrivateRoute>
          } 
          />

          <Route path="/profilo" element={
            <PrivateRoute roles={['CLIENTE', 'SAT']}>
              <ProfiloPage />
            </PrivateRoute>
          } 
          />

          <Route path="/riparazione" element={
            <PrivateRoute roles={['CLIENTE']}>
              <RiparazioneForm />
            </PrivateRoute>
          } 
          />

          <Route path="/DOA" element={
            <PrivateRoute roles={['CLIENTE']}>
              <DOAForm />
            </PrivateRoute>
          } 
          />

          <Route path="/MerceDanneggiata" element={
            <PrivateRoute roles={['CLIENTE']}>
              <MerceDanneggiataForm />
            </PrivateRoute>
          } 
          />
          
          <Route path="/MerceNonConforme" element={
            <PrivateRoute roles={['CLIENTE']}>
              <MerceNonConformeForm />
            </PrivateRoute>
          } 
          />

          <Route path="/dettaglioResi" element={
            <PrivateRoute roles={['CLIENTE']}>
              <TabelleResi />
            </PrivateRoute>
          } 
          />

          <Route path="/dashboard" element={
            <PrivateRoute roles={['SAT']}>
              <DashboardSAT />
            </PrivateRoute>
          } 
          />

          <Route path="/chat" element={
            <PrivateRoute roles={['SAT']}>
              <ChatPageSAT />
            </PrivateRoute>
          } 
          />

          <Route path="/chat1" element={
            <PrivateRoute roles={['CLIENTE']}>
              <ChatPageCliente />
            </PrivateRoute>
          } 
          />

          <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
